// Test.js
import React, { useCallback, useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Question from "./question";

const CONTAINER_STYLE = { margin: "20px" };
const TIMER_STYLE = { textAlign: "right" };
const NAV_STYLE = {
	textAlign: "center",
	marginTop: "20px",
	display: "flex",
	justifyContent: "space-between",
};

const Test = ({ onSubmit, questions, scoretemp, questionsduration }) => {
	const questionsData = questions;
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [answers, setAnswers] = useState(
		Array(questionsData.length).fill(null)
	);
	const [timeLeft, setTimeLeft] = useState(
		questionsData.length * 60 * questionsduration
	);

	useEffect(() => {
		if (timeLeft === 0) {
			handleSubmit();
			return;
		}
		const timer = setInterval(() => {
			setTimeLeft((prevTime) => prevTime - 1);
		}, 1000);
		return () => clearInterval(timer);
	}, [timeLeft]);

	const handleSelectAnswer = useCallback(
		(questionIndex, answerIndex, option) => {
			const newAnswers = [...answers];
			newAnswers[questionIndex] = option;
			setAnswers(newAnswers);
		},
		[answers]
	);

	const handleSubmit = useCallback(() => {
		let score = 0;
		questionsData.forEach((question, index) => {
			if (question.answer === answers[index]) {
				score++;
			}
		});
		onSubmit(answers);
		scoretemp(score);
	}, [answers, onSubmit, questionsData, scoretemp]);

	return (
		<div style={CONTAINER_STYLE}>
			<div style={TIMER_STYLE}>
				Time left: {Math.floor(timeLeft / 60)}:{timeLeft % 60 < 10 ? "0" : ""}
				{timeLeft % 60}
			</div>
			<Question
				question={questionsData[currentQuestion]}
				index={currentQuestion}
				onSelectAnswer={handleSelectAnswer}
				selectedAnswer={answers[currentQuestion]}
			/>
			<div style={NAV_STYLE}>
				<Button
					onClick={() => setCurrentQuestion(currentQuestion - 1)}
					disabled={currentQuestion === 0}>
					Previous
				</Button>
				{currentQuestion < questionsData.length - 1 ? (
					<Button onClick={() => setCurrentQuestion(currentQuestion + 1)}>
						Next
					</Button>
				) : (
					<Button onClick={handleSubmit}>Submit</Button>
				)}
			</div>
		</div>
	);
};

export default Test;
